import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessField } from 'types/dataTableTypes';

/**
 * Hook for generating empty state text for field tables
 */
export const useEmptyState = {
  /**
   * Get empty state text for system fields table
   */
  useSystemFieldsEmptyState: (
    allFields: ProcessField[],
    filteredFields: ProcessField[]
  ) => {
    const { t } = useTranslation();

    return useMemo(() => {
      if (allFields.length > 0 && filteredFields.length === 0) {
        return t('data-tables.system-fields.no-system-fields');
      }
      return undefined;
    }, [allFields.length, filteredFields.length, t]);
  },

  /**
   * Get empty state text for custom fields table
   */
  useCustomFieldsEmptyState: (
    hasNoForms: boolean,
    hasNoCustomFieldsForForm: boolean
  ) => {
    const { t } = useTranslation();

    return useMemo(() => {
      if (hasNoForms) {
        return t('data-tables.custom-fields.no-forms');
      }
      if (hasNoCustomFieldsForForm) {
        return t('data-tables.custom-fields.no-fields-for-form');
      }
      return undefined;
    }, [hasNoForms, hasNoCustomFieldsForForm, t]);
  },
};
